module.exports = __webpack_public_path__ + "static/watering_plant-3e9b6a442560338752658491550a9312.svg";